import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AddContentPopover;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@instructure/ui-popover';
import { jsx } from '@instructure/emotion';
import CustomPropTypes from '../../../../../util/CustomPropTypes';
import { onPhone, onTablet } from '../../../../../util/windowChecks';
import AddContentButton from '../Button';
import AddContentBody from '../Body';
import { DELETED_QUIZ_ENTRY, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var AddContentPopover = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_AddContentPopover = /*#__PURE__*/function (_Component) {
  function AddContentPopover() {
    var _this;
    _classCallCheck(this, AddContentPopover);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddContentPopover, [].concat(args));
    _defineProperty(_this, "showContent", function () {
      _this.props.switchOnEditing();
    });
    _defineProperty(_this, "hideContent", function () {
      _this.props.switchOffEditing();
    });
    _defineProperty(_this, "storePopoverTriggerRef", function (b) {
      _this.popoverTrigger = b;
    });
    _defineProperty(_this, "renderPopoverButton", function () {
      return jsx(Popover, {
        on: "click",
        onShowContent: _this.showContent,
        onHideContent: _this.hideContent,
        isShowingContent: _this.props.isEditing,
        shouldCloseOnEscape: true,
        shouldContainFocus: true,
        renderTrigger: _this.renderAddContentButton()
      }, jsx(AddContentBody, {
        allowStimulusCreation: _this.props.allowStimulusCreation,
        onOpenBankTray: _this.props.switchOffEditing,
        onAddItem: _this.props.switchOffEditing,
        parentEntryId: _this.props.parentEntryId,
        position: _this.props.position,
        quizId: _this.props.quizId,
        stimulusId: _this.props.stimulusId
      }));
    });
    _defineProperty(_this, "openAddContentModal", function () {
      _this.props.openAddContentModal({
        allowStimulusCreation: _this.props.allowStimulusCreation,
        parentEntryId: _this.props.parentEntryId,
        position: _this.props.position,
        quizId: _this.props.quizId,
        stimulusId: _this.props.stimulusId
      });
    });
    return _this;
  }
  _inherits(AddContentPopover, _Component);
  return _createClass(AddContentPopover, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      if (this.props.shouldFocus) {
        setTimeout(function () {
          _this2.popoverTrigger && _this2.popoverTrigger.focus();
          _this2.props.clearUi(DELETED_QUIZ_ENTRY);
        }, 100); // force after modal attempt to refocus delete button
      }
    }
  }, {
    key: "renderAddContentButton",
    value: function renderAddContentButton() {
      var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return jsx(AddContentButton, {
        ref: this.storePopoverTriggerRef,
        onClick: onClick,
        isEditing: this.props.isEditing,
        useStimulusTrigger: this.props.useStimulusTrigger
      });
    }
  }, {
    key: "renderModalButton",
    value: function renderModalButton() {
      return this.renderAddContentButton(this.openAddContentModal);
    }
  }, {
    key: "render",
    value: function render() {
      var borderLine = this.props.useStimulusTrigger ? null : jsx("div", {
        css: this.props.styles.borderLine
      });
      var button = this.props.isMobile ? this.renderModalButton() : this.renderPopoverButton();
      return jsx("div", {
        css: this.props.styles.wrapper,
        "data-automation": "sdk-build-add-content"
      }, borderLine, button);
    }
  }]);
}(Component), _defineProperty(_AddContentPopover, "displayName", 'AddContentPopover'), _defineProperty(_AddContentPopover, "componentId", "Quizzes".concat(_AddContentPopover.displayName)), _defineProperty(_AddContentPopover, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  allowStimulusCreation: PropTypes.bool,
  clearUi: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  openAddContentModal: PropTypes.func.isRequired,
  parentEntryId: PropTypes.string,
  position: PropTypes.number.isRequired,
  quizId: PropTypes.string.isRequired,
  shouldFocus: PropTypes.bool.isRequired,
  stimulusId: PropTypes.string,
  switchOffEditing: PropTypes.func.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  useStimulusTrigger: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_AddContentPopover, "defaultProps", {
  allowStimulusCreation: true,
  isMobile: onPhone() || onTablet(),
  parentEntryId: null,
  stimulusId: null,
  useStimulusTrigger: false
}), _AddContentPopover)) || _class);
export default AddContentPopover;